"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var React = require("react");
var react_hot_toast_1 = require("react-hot-toast");
var react_query_1 = require("react-query");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var config_action_1 = require("../../../actions/config_action");
var api_service_1 = require("../../../api/api_service");
var button_component_1 = require("../../../common/buttons/button_component");
var drop_down_component_1 = require("../../../common/drop_down/drop_down_component");
var pop_up_1 = require("../../../common/modal/pop-up");
var react_paginate_1 = require("../../../common/react_pagination/react_paginate");
var AGgrid_table_component_1 = require("../../../common/tables/AGgrid_table_component");
var text_filed_with_fromto_Daterange_1 = require("../../../common/text_filed/text_filed_with_fromto_Daterange");
var appConstants_1 = require("../../../constants/appConstants");
var route_path_1 = require("../../../constants/route_path");
var table_data_1 = require("../../../constants/table_data");
var menu_constants_1 = require("../../../menuList/menu_constants");
var array_helpers_1 = require("../../../utils/array_helpers");
var auto_routing_api_calls_1 = require("../control_dashboard/auto_routing_api_calls");
var OndeamndSSoList = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var pathname = (0, react_router_1.useLocation)().pathname;
    var nav = (0, react_router_1.useNavigate)();
    var _a = React.useState(), errorMessage = _a[0], setErrorMessage = _a[1];
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var _c = React.useState(appConstants_1.defaultPageLimit), PageLimit = _c[0], setPageLimit = _c[1];
    var _d = React.useState(0), totalPageCount = _d[0], setTotalPageCount = _d[1];
    var _e = React.useState(1), pageCount = _e[0], setpageCount = _e[1];
    var _f = React.useState(0), totalCount = _f[0], setTotalCount = _f[1];
    var _g = React.useState([]), onDemandList = _g[0], setOnDemandList = _g[1];
    var _h = React.useState(''), startDate = _h[0], setStartDate = _h[1];
    var _j = React.useState(''), endDate = _j[0], setEndDate = _j[1];
    var _k = React.useState(false), isDateRangeUpdated = _k[0], setIsDateRangeUpdated = _k[1];
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.controlTower);
    var callBackOnDateRangeSelect = function (dateRangeArray) {
        if (dateRangeArray === null) {
            setStartDate(null);
            setEndDate(null);
        }
        if (dateRangeArray) {
            setStartDate(moment(dateRangeArray.start).format('YYYY-MM-DD'));
            setEndDate(moment(dateRangeArray.end).format('YYYY-MM-DD'));
        }
        setIsDateRangeUpdated(!isDateRangeUpdated);
    };
    var callBackOnPageLimitChange = function (val) {
        setPageLimit(val);
    };
    var handlePageClick = function (data) {
        var currentPage = data.selected + 1;
        setpageCount(currentPage);
    };
    var createOndemandHandlere = function () {
        if (pathname.includes("".concat(route_path_1.default.PATHS.sso_ondemandRequest))) {
            nav("".concat(route_path_1.default.PATHS.sso_ondemandRequest_create));
        }
        else {
            nav("".concat(route_path_1.default.PATHS.onDemandRequest));
        }
    };
    var navigateToMyReports = function () {
        dispatch((0, config_action_1.featchCurrentActiveMenu)({
            mainModule: menu_constants_1.FEATURE_CONSTANTS.sub_my_reports,
            subModule: '',
            subChaildModule: '',
        }));
        nav("/".concat(route_path_1.default.PATHS.MYREPORTS));
    };
    var autoGenerateReportHandler = function () {
        var currentPage = pageCount < 1 ? 1 : pageCount;
        var payload = {};
        payload['page'] = currentPage;
        payload['size'] = PageLimit ? parseInt(PageLimit.value.toString()) : 50;
        payload['filter'] = 1;
        if (startDate && endDate) {
            var dateRangeObj = {
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD'),
            };
            payload['date_range'] = dateRangeObj;
        }
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.auto_routing_on_demand_generate,
            payLoad: payload,
            domain: process.env.APPROVAL_BASEURL,
        })
            .then(function (res) {
            if (res.data.statusCode === 200) {
                if (res.data.message != 'Success') {
                    react_hot_toast_1.toast.error(res.data.message);
                }
                else {
                    setOpen(true);
                }
            }
            else {
                react_hot_toast_1.toast.error(res.data.message);
            }
        })
            .catch(function (err) {
            react_hot_toast_1.toast.error(err.data.errors);
        });
    };
    var refetch = (0, react_query_1.useQuery)(['ondemand-request-list', pageCount], function () {
        var todaysDate = new Date();
        var currentPage = pageCount || 1;
        var payload = {
            filter: 1,
        };
        payload.page = currentPage;
        payload.size = PageLimit ? parseInt(PageLimit.value.toString()) : 50;
        if (startDate && endDate) {
            var dateRangeObj = {
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD'),
            };
            payload['date_range'] = dateRangeObj;
        }
        else if (startDate === '') {
            payload.date_range = {
                start_date: (0, array_helpers_1.dateFormateYMD)(todaysDate),
                end_date: (0, array_helpers_1.dateFormateYMD)(todaysDate),
            };
        }
        (0, auto_routing_api_calls_1.onDemandPickupList)(payload)
            .then(function (response) {
            var pageSize = PageLimit
                ? parseInt(PageLimit.value.toString())
                : 50;
            var count = Math.ceil(response.count / pageSize);
            setTotalPageCount(count);
            setTotalCount(response.count);
            setOnDemandList(response.result);
        })
            .catch(function (err) {
            setOnDemandList([]);
            setErrorMessage(err.message);
        });
    }).refetch;
    React.useEffect(function () {
        if (pageCount != 1) {
            setpageCount(1);
        }
        else {
            refetch();
        }
    }, [isDateRangeUpdated, PageLimit]);
    var renderFilterMenu = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "filter-menu-wrapper" },
                React.createElement("div", { className: "search-filter search-lg" }),
                React.createElement("div", { className: "filter-options" },
                    React.createElement(text_filed_with_fromto_Daterange_1.default, { onChangeHandler: callBackOnDateRangeSelect, presentDate: true }),
                    React.createElement(drop_down_component_1.default, { dropDownList: appConstants_1.paginationDropdown, onChange: callBackOnPageLimitChange, value: PageLimit })))));
    };
    var renderDataTable = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "scrollable-content" },
                React.createElement("div", { className: "bookmark-checkbox" },
                    React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.ONDEMAND_PICKUP_COLUMNS, rows: onDemandList, pagination: false, errorMessage: errorMessage }),
                    React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: onDemandList === null || onDemandList === void 0 ? void 0 : onDemandList.length, currentPageLimits: PageLimit === null || PageLimit === void 0 ? void 0 : PageLimit.value }),
                    React.createElement(pop_up_1.default, { open: open },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h2", { className: "heading" }, "Request Submitted"),
                            React.createElement("h2", { className: "sub-heading" }, "Please view your report in My Reports section")),
                        React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                            React.createElement(button_component_1.default, { buttonName: "Cancel", color: "yellow-outline", isError: false, onClickHandler: function () { return setOpen(false); } }),
                            React.createElement(button_component_1.default, { buttonName: "My Reports", color: "yellow", onClickHandler: navigateToMyReports, isError: false })))))));
    };
    return (React.createElement("div", { className: "page-wrapper audit-wrapper" },
        React.createElement("div", { className: "tool-bar-wrapper" },
            React.createElement("div", { className: "page-heaidng" },
                React.createElement("h2", null, "On Demand Pickups")),
            React.createElement("div", { className: "page-control-wrapper" },
                React.createElement(button_component_1.default, { type: "button", buttonName: appConstants_1.reportDownload, color: "yellow-outline", endIcon: "icon-import download-icon", isError: !features[menu_constants_1.FEATURE_CONSTANTS.Control_tower_Download] ||
                        onDemandList.length <= 0, onClickHandler: autoGenerateReportHandler }),
                React.createElement(button_component_1.default, { id: "myForm", onClickHandler: createOndemandHandlere, buttonName: "ON DEMAND CREATION", color: "yellow" }))),
        renderFilterMenu(),
        renderDataTable()));
};
exports.default = OndeamndSSoList;
